import {IStackListItem} from '@/lib/types/common-types';
import PipeList from './PipeList';
import AlternateIdLink from "./AlternateIdLink"
import languageCodeLookup from "@/lib/types/language-code-lookup";

export default function StackList({field, data, items}: { field: string, data: any, items: IStackListItem[] }) {


    let isLink = false;

    /**
     * Hack Alert.
     * @param item
     * @constructor
     */
    const LinkOrTitle = ({item}) => {
        //console.log("LinkOrTitle: ", item, " field: ", field, " data: ", data, " items: ", items, "")
        switch (field) {
            case "OriginalLanguage":
                item.value = languageCodeLookup[item.value]?.name || item.value;
                return <span>{item.value}</span>;
                break;
            case "AlternateID" :
                let match = item.pipeList.find((item) => {
                    return item.name === '_domain' || item.name === "_type"
                })

                if (match) {
                    //console.log("match: ", match.value)
                    return (
                        <AlternateIdLink
                            domain={match.value}
                            value={item.value}
                        ></AlternateIdLink>
                    );
                }
                break;
            default:
                return <span>{item.value}</span>;

        }


    };

    return (
        <div className="stack-list">
            {items.map((item, index) => (
                <div className="p-2" key={`${item.value}-${index}`}>
                    <strong>
                        <LinkOrTitle item={item}/>
                    </strong>
                    {item.pipeList ? <PipeList fields={item.pipeList}/> : null}
                </div>
            ))}
        </div>
    );
}
